module.exports = __webpack_public_path__ + "img/selected4-min.00f24a60.png";